import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { OnboardingClientConfigService } from '@zero/onboarding/domain';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'saving-plans-confirm-config-items',
  imports: [AsyncPipe, TranslocoPipe, NgTemplateOutlet, ButtonComponent],
  templateUrl: './savings-plan-confirm-config-items.component.html',
})
export class SavingsPlanConfirmConfigItemsComponent implements OnInit {
  public readonly service = inject(OnboardingClientConfigService);

  ngOnInit(): void {
    this.reloadConfig();
  }

  public reloadConfig(): void {
    this.service.reset();
    this.service.triggerLoadClientConfigForSavingsplanCommonDocuments();
  }
}
